import {Trans} from '@lingui/macro';
import React from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {OkCancelDialog} from '../../../../components/common/dialogs/okCancelDialog';

/*
 * Type.
 */

interface LoadBalancingDialogProps {
  onOk: Handler;
  onCancel: Handler;
}

/*
 * Component.
 */

export const LoadBalancingDialog = ({onOk, onCancel}: LoadBalancingDialogProps) => (
  <OkCancelDialog
    title={<Trans id="rule-disable-load-balancing-title">Disable Load Balancing</Trans>}
    okButtonLabel={<Trans id="rule-disable-load-balancing-confirm">Confirm</Trans>}
    onOkClick={onOk}
    onRequestClose={onCancel}
  >
    <Trans id="rule-disable-load-balancing-message">
      You are about to disable a load balancing rule. The queue of conversations still to be assigned will be
      purged. Do you wish to disable this rule?
    </Trans>
  </OkCancelDialog>
);
